import FastFood from './FastFood'
export default FastFood